import Vue from "vue";
import BigNumber from "bignumber.js";
// 钱包类
let contractMapping = new Map();
export default class BasicWallet extends Vue {
    // 设置控制器
    async setContract (contractKey, contract) {
        contractMapping.set(contractKey, contract);
    }

    // 获取控制器
    async getContract (contractKey) {
        return contractMapping.get(contractKey)
    }

    // 调用钱包签名
    async signMsg () {
        return this.web3.web3.eth.personal.sign(this.web3.userAddress, this.web3.userAddress, 'password')
    }

    // 精度计算乘法
    async precisionTimes(data,digit){
        let digitPrecision = new BigNumber(10).pow(digit);
        return new BigNumber(Number(data)).times(digitPrecision).toFixed(0,BigNumber.ROUND_DOWN)
    }
     // 精度计算除法
    async precisionDiv(data,digit,retain){
        let digitPrecision = new BigNumber(10).pow(digit);
        if(retain){
            return new BigNumber(Number(data)).div(digitPrecision).toNumber().toFixed(retain);
        }
        return new BigNumber(Number(data)).div(digitPrecision).toFixed(0,BigNumber.ROUND_DOWN)
    }
    // 时间戳处理
    async formatTimestamp(timestamp) {
        // 将传入的时间戳转换为字符串并去除可能存在的非数字字符（例如小数点）
        const timestampStr = String(Math.floor(Number(timestamp)));
    
        let formattedDate; 
        if (timestampStr.length === 10) {
            // 如果是10位，认为它是秒级时间戳，需要转换成毫秒
            formattedDate = new Date(Number(timestampStr) * 1000);
        } else if (timestampStr.length === 13) {
            // 如果是13位，认为它是毫秒级时间戳，直接使用
            formattedDate = new Date(Number(timestampStr));
        } else if (timestampStr.length > 13) {
            // 如果超过13位，截取前13位作为毫秒级时间戳
            formattedDate = new Date(Number(timestampStr.slice(0, 13)));
        } else {
            // 对于其他情况，返回无效日期信息
            return 'Invalid Timestamp';
        }
    
        // 检查是否是有效的日期
        if (isNaN(formattedDate.getTime())) {
            return 'Invalid Date';
        }
    
        // 格式化日期为 YYYY-MM-DD HH:mm:ss 的本地时间格式
        const year = formattedDate.getFullYear();
        const month = String(formattedDate.getMonth() + 1).padStart(2, '0'); // 月份从0开始
        const day = String(formattedDate.getDate()).padStart(2, '0');
        const hours = String(formattedDate.getHours()).padStart(2, '0');
        const minutes = String(formattedDate.getMinutes()).padStart(2, '0');
        const seconds = String(formattedDate.getSeconds()).padStart(2, '0');
    
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
}
Vue.prototype.basicWallet = new BasicWallet()